module.exports = __webpack_public_path__ + "img/_3.152ec7f5.png";